import { GasMovementTypes } from "./types";


const {
    GET_GAS_MOVEMENTS_REQUESTS,
    NEW_GAS_MOVEMENT,
    EDIT_GAS_MOVEMENT,
    SET_CONFIG_FILTERED_GAS_MOVEMENTS,
    SET_CONFIG_PAGE_GAS_MOVEMENTS,
    SET_CONFIG_PAGE_GAS_MOVEMENTS_COUNT,
    SET_CONFIG_SORTED_GAS_MOVEMENTS,
    SET_STATION,
    UPDATE_STATUS,
    DELETE_MOVEMENT,
    RESTORE_INITIAL
} = GasMovementTypes;


const initialState = {
    gasMovements: [],
    station: null,
    config: {
        pageSize: 15,
        page: 0,
        sorted: [],
        filtered: [],
    },
}

export const gasMovementsRequestsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_GAS_MOVEMENTS_REQUESTS:
            return {
                ...state,
                gasMovements: payload
                // gasMovements: payload.map(x => ({...x, movement: null}))
            }
        case NEW_GAS_MOVEMENT:
            return {
                ...state,
                gasMovements: [{...payload}, ...state.gasMovements]
            }
        case EDIT_GAS_MOVEMENT: 
            const gasMovements = [...state.gasMovements]
            const i = gasMovements.findIndex(mov => mov.id === payload.id)
            if (i < 0) {
                return state
            }
            gasMovements[i] = {
                ...gasMovements[i],
                ...payload,
            }
            return {
                ...state,
                gasMovements
            }
        case UPDATE_STATUS:
            const gasState = [...state.gasMovements]
            const idx = gasState.findIndex(mov => mov.id === payload.id)
            gasState[idx].status = payload.status
            return {
                ...state,
                gasMovements:gasState
            }
        case SET_STATION:
            return {
                ...state,
                station: payload,
            }
        case SET_CONFIG_FILTERED_GAS_MOVEMENTS:
            return {
                ...state,
                config: {
                    ...state.config,
                    filtered: payload,
                    page: 0,
                },
            };
        case DELETE_MOVEMENT:
            return {
                ...state,
                gasMovements: state.gasMovements.filter(mov => mov.id !== payload)
            }
        case SET_CONFIG_PAGE_GAS_MOVEMENTS:
            return {
                ...state,
                config: {
                    ...state.config,
                    page: payload,
                },
            };

        case SET_CONFIG_PAGE_GAS_MOVEMENTS_COUNT:
            return {
                ...state,
                config: {
                    ...state.config,
                    pageSize: payload,
                    page: 0,
                },
            };
        case SET_CONFIG_SORTED_GAS_MOVEMENTS:
            return {
                ...state,
                config: {
                    ...state.config,
                    sorted: payload,
                    page: 0,
                },
            };
        case RESTORE_INITIAL:
            return initialState
        default:
            return state
    }
}